<template>
	<el-select
		v-model="cValue"
		clearable
		:placeholder="$attrs.placeholder"
		@change="selchange"
	>
		<el-option
			v-for="(item, index) in options"
			:key="index"
			:label="item.label"
			:value="item.value"
		>
		</el-option>
	</el-select>
</template>
<script>
	export default {
		props: {
			url: {
				type: String
			},
			type: {
				type: String
			},
			value: {
				default: ''
			}
		},
		inheritAttrs: false,
		data() {
			return {
				options: [],
				cValue: this.value,
			}
		},
		methods: {
			getOptions() {
				console.info("dc-select getOptions")
				let type = this.type || this.url.split('=').pop();
				this.$store.getters.getDict(type).then(res => {
					this.options = res;
				});
			},
			selchange() {
				this.$emit('input', this.cValue)
			}
		},
		mounted() {
			this.getOptions()
		},
		updated() {
			this.cValue = this.value;
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/dc-select/index.vue